import { Link } from "react-router-dom";
import { titles } from "@/mocks/titles";

const entries = [
  {
    type: "movie" as const,
    title: "电影",
    subtitle: "Movies",
    icon: "ri-film-line",
    description: "院线新片、影史经典与冷门佳片，按类型精准筛选。",
    stats: `${titles.filter((item) => item.type === "movie").length} 部作品`,
    image:
      "https://readdy.ai/api/search-image?query=artistic%20cinema%20projector%20beam%20cutting%20through%20dusty%20dark%20theater%20air%20deep%20navy%20shadows%20warm%20amber%20light%20minimal%20elegant%20no%20text&width=900&height=560&seq=entry-movie&orientation=landscape",
  },
  {
    type: "tv" as const,
    title: "电视剧",
    subtitle: "TV Series",
    icon: "ri-live-line",
    description: "悬疑罪案、古装年代与都市生活，追剧一次看全。",
    stats: `${titles.filter((item) => item.type === "tv").length} 部剧集`,
    image:
      "https://readdy.ai/api/search-image?query=cozy%20evening%20living%20room%20scene%20with%20warm%20amber%20lamp%20and%20a%20glowing%20screen%20reflection%20on%20deep%20navy%20wall%20minimal%20cinematic%20no%20text&width=900&height=560&seq=entry-tv&orientation=landscape",
  },
];

export default function CategoryEntries() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="mx-auto max-w-[1440px]">
        <div className="mb-8 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs tracking-[0.18em] text-accent-600">
              <span className="inline-block h-3 w-0.5 bg-accent-500"></span>
              快速入口
            </p>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">想看什么，从这里开始</h2>
          </div>
          <p className="text-sm text-foreground-600">两大主分类，共 {titles.length} 部精选作品</p>
        </div>

        <div className="grid grid-cols-1 gap-4 md:gap-6 lg:grid-cols-2">
          {entries.map((entry) => (
            <Link
              key={entry.type}
              to={`/category/${entry.type}`}
              className="group relative flex h-[260px] w-full overflow-hidden rounded-lg border border-background-200 bg-primary-950 cursor-pointer md:h-[300px]"
            >
              <img
                src={entry.image}
                alt={`${entry.title}分类入口`}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-950/95 via-primary-950/70 to-primary-900/25"></div>
              <div className="relative z-10 flex w-full flex-col justify-between p-5 md:p-7">
                <div className="flex items-start justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-500 text-primary-950">
                    <i className={`${entry.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <span className="rounded-md bg-background-50/15 px-2 py-1 text-[11px] text-background-100 backdrop-blur">
                    {entry.stats}
                  </span>
                </div>
                <div>
                  <p className="text-[10px] tracking-[0.24em] text-primary-200">{entry.subtitle}</p>
                  <h3 className="mt-1 font-heading text-2xl font-bold text-background-50 md:text-3xl">
                    {entry.title}
                  </h3>
                  <p className="mt-2 max-w-sm text-sm leading-relaxed text-background-200">{entry.description}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm text-secondary-400">
                    进入分类
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}